import { SicaCatalogContext } from '../../models/profiles-permissions/sicaRouteCatalog.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { endpoints } from 'environments/endpoints';
import { TeraComponent } from '../../models/profiles-permissions/teraComponent.model';
import { HttpHeadersUtil } from 'app/shared/utils/http-headers.util';

@Injectable({
  providedIn: 'root'
})
export class TeraComponentService {
  private baseRoute = environment.GATEWAY_API + endpoints.teraComponent.baseRoute;
  private subRoutes = endpoints.teraComponent.subRoutes;

  constructor(private readonly _httpClient: HttpClient) {}

  getAll(isSica?: boolean): Observable<TeraComponent[]> {
    return this._httpClient.get<TeraComponent[]>(
      `${this.baseRoute}${endpoints.teraComponent.subRoutes.getAll}${this.buildPlatformQuery(isSica)}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  add(teraComponent: TeraComponent, isSica?: boolean): Observable<TeraComponent> {
    return this._httpClient.post<TeraComponent>(
      `${this.baseRoute}${endpoints.teraComponent.subRoutes.add}${this.buildPlatformQuery(isSica)}`,
      teraComponent,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  getSicaPermissionCatalog(): Observable<SicaCatalogContext[]> {
    return this._httpClient.get<SicaCatalogContext[]>(
      `${this.baseRoute}${this.subRoutes.getSicaPermissionCatalog}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  syncSicaPermissions(): Observable<void> {
    return this._httpClient.post<void>(
      `${this.baseRoute}${this.subRoutes.syncSicaPermissions}`,
      {},
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  update(teraComponent: TeraComponent): Observable<TeraComponent> {
    return this._httpClient.put<TeraComponent>(
      `${this.baseRoute}${endpoints.teraComponent.subRoutes.update}`,
      teraComponent,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  delete(id: string): Observable<{ success: boolean }> {
    return this._httpClient.delete<{ success: boolean }>(
      `${this.baseRoute}${this.subRoutes.delete + id}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  getDataChanges(id: string): Observable<string> {
    return this._httpClient.get<string>(
      `${this.baseRoute}${this.subRoutes.getDataChanges + id}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  private buildPlatformQuery(isSica?: boolean): string {
    return isSica === undefined || isSica === null ? '' : `?isSica=${isSica}`;
  }
}
